import * as Sentry from "@sentry/react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  getBankDetails,
  updateBankDetails,
} from "../../../setup/api/services/bank";
import {
  IBankDetailsBody,
  IBankDetailsResponseData,
} from "../../../setup/api/services/bank/model";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { ALERT } from "../address/address";
import AddPayment from "./addPayment";
// components
import NoCard from "./noCard";

const Payment = () => {
  const userId = AuthConfig.getUserInfo().id;
  const [showBank, setShowBank] = useState<boolean>(false);
  const [bank, setBank] = useState<IBankDetailsResponseData | undefined>(
    undefined
  );
  const [alert, setAlert] = useState<ALERT>(ALERT.NONE);
  const { t } = useTranslation();

  const [success, setSuccess] = useState<boolean>(true);
  const getBank = useCallback(async (userId) => {
    try {
      const response = await getBankDetails(userId);
      if (response?.data) setBank(response?.data);
    } catch (error) {
      Sentry.captureException(error);
      console.error(error);
    }
  }, []);

  const updateBankInfo = useCallback(
    async (body: IBankDetailsBody) => {
      try {
        await updateBankDetails(userId, body);
        setAlert(ALERT.SUCCESS);
        setSuccess(true);
      } catch (error) {
        Sentry.captureException(error);
        setAlert(ALERT.ERROR);
        setSuccess(false);
      }
    },
    [userId]
  );

  useEffect(() => {
    if (userId) getBank(userId);
  }, [userId, getBank]);

  if (showBank || bank) {
    return (
      <AddPayment
        userBank={bank}
        updateBankInfo={updateBankInfo}
        alert={alert}
        success={success}
      />
    );
  }

  return (
    <NoCard
      handleClick={() => {
        setShowBank(!showBank);
        setSuccess(false);
      }}
    />
  );
};

export default Payment;
